import Branding from './Branding';
import BrandingStyles from './BrandingStyles';

export default Branding;
export { BrandingStyles };
